import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {TeachingTool} from '../../models/teaching-tool';
import {Common} from '../../lib/common';
import {MessagePopoverComponent} from '../message-popover/message-popover.component';
import {PopoverController} from '@ionic/angular';
import { ResourcesCssService } from 'src/app/pages/resources/resources-css.service';

@Component({
  selector: 'app-teaching-tool',
  templateUrl: './teaching-tool.component.html',
  styleUrls: ['./teaching-tool.component.scss'],
})
export class TeachingToolComponent implements OnInit {

  @Input() tool: TeachingTool
  @Input() icon: string

  constructor(
    private popoverCtrl: PopoverController,
    public resourcesCssService: ResourcesCssService
  ) { }

  ngOnInit() {
    if (Common.isNullOrUndefined(this.icon)) {
      this.icon = this.tool.icon
    }
  }

  play() {
    // Some of the songs have garbage text after the url, usually separated by a newline
    const n = this.tool.url.indexOf('\n')
    const url = this.tool.url.substring(0, n === -1 ? this.tool.url.length : n)
    if (url) {
      window.open(url, '_blank')
    } else {
      MessagePopoverComponent.present(this.popoverCtrl, 'No URL', 'This item cannot be displayed because it does not have a url.', true, false, [])
    }
  }

}
